<template>
  <div class="products-tab">
    <artmisads-table
      :columns="columns"
      :data-source="tableData"
       v-model:pagination="pagination"
       :change="onTableChange"
      :scroll="{ x: 980 }"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'product'">
          <div class="product-cell">
            <div >
              <LogoImage :logoUrl="record.imageUrl" :brandName="record.productTitle" />
            </div>
           
            <div>
              <a-tooltip :title="record.productTitle" placement="top">
                <div class="product-link">
                  {{ record.productTitle }}
                </div>
              </a-tooltip>
              <div class="asin-link">
                {{ record.asin }}
              </div>
            </div>
            <!-- <a href="javascript:void(0)" class="product-link">{{ record.productTitle }}</a> -->
          </div>
        </template>
        <template v-if="column.key === 'clicks'">
          <div class="metric-cell">
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                 <span class="item-text">Attribution</span>
               </div>
              </div>
              <div class="num">
                {{ record.attributionClicks||0 }}
              </div>
            </div>
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                 <span class="item-text">Associate</span>
               </div>
              </div>
              <div class="num">
                {{ record.associateClicks||0 }}
              </div>
            </div>
          </div>
        </template>
        <template v-if="column.key === 'sales'">
          <div class="metric-cell">
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                 <span class="item-text">Attribution</span>
               </div>
              </div>
              <div class="num">
              {{ currency }}  {{ record.attributionSalesAmount||0 }}
              </div>
            </div>
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                 <span class="item-text">Associate</span>
               </div>
              </div>
              <div class="num">
              {{ currency }}  {{ record.associateSalesAmount||0 }}
              </div>
            </div>
          </div>
          <!-- <div class="metric-cell">
            <div><span class="dot">.</span> Attribution <span class="num">{{ record.attributionSalesAmount||0 }}</span></div>
            <div><span class="dot">.</span> Associate <span class="num">{{ record.associateSalesAmount||0 }}</span></div>
          </div> -->
        </template>
        <template v-if="column.key === 'publishers'">
          <div href="javascript:void(0)" class="publisher-link" @click="openDetails(record)">
            {{ record.joinedPublisherCount }}
          </div>
        </template>
      </template>
    </artmisads-table>

    <AsinDetailsModal ref="asinDetailsModalRef" />
  </div>
</template>

<script setup>
import { ref,onMounted,reactive } from "vue"
import AsinDetailsModal from "./AsinDetailsModal.vue"
import LogoImage from "@/components/LogoImage.vue"
import { sellerCpcApi } from "~/server"
import { CURRENCY_MAPPER } from "@/contants/common"
import { useUserInfoStore } from "@/storeData"
const user = useUserInfoStore()
const currency = CURRENCY_MAPPER[user.userInfo?.countryCode]?.currency || '$'
const props = defineProps({
  id: {
    type: String||Number,
    required: true,
  },
})
const pagination = reactive({
  total: 0,
  defaultPageSize: 10,
  size: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ["1", "20", "30", "40", "50"],
})
const columns = [
  { title: "Product", dataIndex: "productName", key: "product", width: 300 },
  { title: "Brand", dataIndex: "brandName", key: "brandName", width: 120 },
  { title: "Amazon Seller Name", dataIndex: "amazonSellerName", key: "amazonSellerName", width: 180 },
  { title: "Clicks", key: "clicks", width: 200 },
  { title: "Sales", key: "sales", width: 200 },
  { title: "Publishers", dataIndex: "publishers", key: "publishers", width: 120 },
]

const tableData = ref([])
onMounted(()=>{
  getCpcCampaignsProducts()

})
const getCpcCampaignsProducts = () => {
  sellerCpcApi.getCpcCampaignsProducts({ campaignId: props.id, page: pagination.current, size: pagination.size }).then(res => {
    tableData.value = res.data.data
    pagination.total = res.data.total
  })
}
const onTableChange = ({ current, pageSize }) => {

pagination.current = current
pagination.size = pageSize
pagination.pageSize = pageSize
getCpcCampaignsProducts()
}
const asinDetailsModalRef = ref(null)

const openDetails = (record) => {
  asinDetailsModalRef.value?.openModal(
   {
    ...record,
    campaignId:props.id
   } 
  )
}
</script>

<style scoped lang="less">
.products-tab {
  padding-top: 4px;
}
.brand-logo{
  width: 60px !important;
}
.product-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}


.product-link {
  color: #4b5563;
  text-decoration: underline;
  line-height: 1.3;
  display: block;
  width: 300px;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.asin-link{
  font-family: Sora;
font-weight: 500;
font-size: 12px;
leading-trim: NONE;
line-height: 16px;
letter-spacing: 0.3px;
color: rgba(15, 6, 41, 0.5);
margin-top: 6px;

}
.metric-cell {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.info-item-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .item-row {
    display: flex;
    padding: 3px 4px;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #f1f0f5;
    min-width: 111px;

    .icon {
      width: 20px !important;
      height: 20px !important;
    }

    .item-text {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.3px;
      opacity: 0.7;
    }
  }
.dot {
  margin-right: 6px;
}

.num {
  font-family: Sora;
font-weight: 500;
font-style: Medium;
font-size: 14px;
leading-trim: NONE;
line-height: 19px;
letter-spacing: 0px;
text-transform: uppercase;
color: rgba(15, 6, 41, 0.7);
}

.publisher-link {
  color: #7d64ff;
  text-decoration: underline;
  cursor: pointer;
}
</style>
